import {NavLink} from "react-router-dom";
import {AuthContext} from "../contexts/AuthContext";
import {useContext} from "react";

function Navbar() {
	const {user, setUser, setToken} = useContext(AuthContext);

	const activeClassName = "nav-link active";

	return (
		<div className={"navbar navbar-expand-lg navbar-light"} style={{backgroundColor: "#f8f9fa"}}>
			<div className={"container-fluid"}>
				<a href="#" className={"navbar-brand"}>
					<img src={"/logo.png"} alt="Datamundi" width="200" style={{marginRight: "6px"}} />
					<span className="ml-2">Manager</span>
				</a>
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
						aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav mx-auto mb-2 mb-lg-0">
						<li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/languages">Languages</NavLink>
						</li>
						<li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/languagePairs">Language pairs</NavLink>
						</li>
						<li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/customers">Customers</NavLink>
						</li>
						<li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/customerTasks">Projects</NavLink>
						</li>
						<li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/workTypes">Work types</NavLink>
						</li>
						{/* <li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/activity">Activity</NavLink>
						</li> */}
						<li className="nav-item">
							<NavLink className={({isActive}) => {
								return isActive ? activeClassName : "nav-link";
							}} to="/purchaseOrders">POs</NavLink>
						</li>
					</ul>
					<ul className={"navbar-nav mb-2 mb-lg-0"}>
						<li className="nav-item dropdown">
							<a className={"nav-link dropdown-toggle"} href="#" id="navbarProfileDropdown" role="button"
							   data-bs-toggle="dropdown" aria-expanded="false">
								My profile
							</a>
							<ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarProfileDropdown">
                                {user.rights.includes("admin") && <li><a className="dropdown-item" href={`https://admin.datamundi.${process.env.REACT_APP_node_env}`}>Admin</a></li>}
                                {user.rights.includes("accountant") && <li><a className="dropdown-item" href={`https://accounting.datamundi.${process.env.REACT_APP_node_env}`}>Accounting</a></li>}
                                {user.rights.includes("pm") && <li><a className="dropdown-item" href={`https://pm.datamundi.${process.env.REACT_APP_node_env}`}>PM</a></li>}
                                {user.rights.includes("qa") && <li><a className="dropdown-item" href={`https://qa.datamundi.${process.env.REACT_APP_node_env}`}>QA</a></li>}
                                {user.rights.includes("freelancer") && <li><a className="dropdown-item" href={`https://freelancer.datamundi.${process.env.REACT_APP_node_env}`}>Freelancer</a></li>}
                                {user.rights.includes("customer") && <li><a className="dropdown-item" href={`https://customer.datamundi.${process.env.REACT_APP_node_env}`}>Customer</a></li>}
                                <li><hr className="dropdown-divider" /></li>
								<li><a href="/Aida_Manager_User_Guide.pdf" target={"_blank"} className={"dropdown-item"}>Help</a></li>
								<li>
                                    <form method="post" action={`${process.env.REACT_APP_endPoint}/v1/auth/logout`}>
                                        <button type="submit" className="dropdown-item">Sign out</button>
                                    </form>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default Navbar;
